import React from 'react';
import { ArrowLeft, Calendar, User, Clock } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { blogService } from '../services/blogService';
import './BlogPostDetail.css';

const BlogPostDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = React.useState(null);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    loadPost();
  }, [id]);

  const loadPost = async () => {
    try {
      setLoading(true);
      const posts = await blogService.getPosts();
      const foundPost = posts.find(p => p.id === id);
      setPost(foundPost);
    } catch (error) {
      console.error('Error loading post:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="blog-post-detail">
        <div className="container">
          <div className="loading">Loading post...</div>
        </div>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="blog-post-detail">
        <div className="container">
          <div className="not-found">
            <h2>Post not found</h2>
            <button onClick={() => navigate('/blog')} className="btn btn-primary">
              Back to Blog
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-post-detail">
      <div className="container">
        <button 
          onClick={() => navigate('/blog')} 
          className="back-btn"
        >
          <ArrowLeft className="back-icon" />
          Back to Blog
        </button>

        <article className="post-content">
          <div className="post-header">
            <div className="post-meta">
              <span className="post-category">{post.category}</span>
              <div className="post-details">
                <span className="post-author">
                  <User className="meta-icon" />
                  Kenny Miles
                </span>
                <span className="post-date">
                  <Calendar className="meta-icon" />
                  {new Date(post.created_at).toLocaleDateString()}
                </span>
                <span className="post-read-time">
                  <Clock className="meta-icon" />
                  {Math.ceil(post.content.length / 500)} min read
                </span>
              </div>
            </div>
            <h1 className="post-title">{post.title}</h1>
            <p className="post-excerpt">{post.excerpt}</p>
          </div>

          <div className="post-body">
            <div className="post-content-text">
              {post.content.split('\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogPostDetail; 